import { Navigate } from 'react-router-dom';
import { useMyCompetitions } from '@/hooks/useCompetitions';
import { useAuthStore } from '@/store/authStore';
import { isSuperAdmin } from '@/lib/roles';
import { isMine } from '@/lib/competitions';
import { PageSpinner } from '@/components/ui/Spinner';
import { CompetitionPickerPage } from '@/pages/CompetitionPickerPage';

/**
 * Sign-in landing. Someone who belongs to exactly one competition goes straight
 * into it (no choice to make); everyone else sees the competition cards.
 * Switching later goes through /competitions, which always shows the cards.
 */
export function HomeRoute() {
  const user = useAuthStore((s) => s.user);
  const { data, isLoading } = useMyCompetitions();
  if (isLoading) return <PageSpinner />;
  const items = (data?.items ?? []).filter(isMine);
  if (!isSuperAdmin(user) && items.length === 1) {
    return <Navigate to={`/competitions/${items[0].competitionId}`} replace />;
  }
  return <CompetitionPickerPage />;
}
